import React, { useContext } from "react";
import { message as Message } from "antd";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import { handleLinkClick } from "@/components/chat/message/AINoticeCard/utils";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { applyApprove, applyReject, approval } from "../api/pageApply";
import API from "@/components/Joyspace/api";
import { useHistory } from "react-router-dom";
import context from "../context";
enum BtnsType {
  APPROVE = "approve",
  REJECT = "reject",
  DETAIL = "detail",
  APPLYAGAIN = "applyAgain"
}
import { changeEgovUrl } from "@/utils/tools";
import { duccConfigI18 } from "@/utils/i18n";
import { ErrorCode } from "../types";
import { analysisLog } from "@/utils/logAnalytics";
import { FolderInfoResMap, JoyspaceState } from "@/models/joyspace";
import IconFont from "@/components/icon";
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return { folderInfoMap: joyspace.folderInfoMap };
}

function mapDispatchToProps(dispatch: any) {
  return {
    addFolderInfo(list: any) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { list } });
    }
  };
}

const JoyspaceNoticeCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ({
    message,
    folderInfoMap,
    addFolderInfo
  }: {
    message: any;
    folderInfoMap: FolderInfoResMap;
    addFolderInfo: any;
  }) => {
    const history = useHistory();
    const { title, extend, infox, id } = message;
    // const { addFolderInfo } = useContext(context);
    console.log(message, "messagemessagemessageJoyspace");
    const [t] = useTranslation("chat");
    // console.log('joyspace notice card', extend);

    const getFolderInfo = (url: string) => {
      // eslint-disable-next-line prefer-regex-literals
      const pattern = new RegExp(`"routeTag":"([^"]+)".*"page_id":"([^"]+)"`);
      const result = url.match(pattern);
      if (result?.length && result?.length > 2 && result[1] === "folder_view") {
        console.log(result, "resultresultresultresult");
        return result;
      }
      return null;
    };

    const doAnalysisLogONCardClick = (isFolder?: boolean, applyType?: string) => {
      const noticeType = message.infox.noticeType;
      let permissionType = "";
      if (["share", "apply"].includes(noticeType)) {
        const fields = message?.extend?.fields || [];
        fields.forEach((field: any) => {
          if (field && field?.key === "permissionType") {
            permissionType = field.value;
          }
        });
      }
      analysisLog(
        "xtbg_jzb_joysapce_inOtherModule_1676971574856",
        applyType ? "2" : "1",
        isFolder ? "folder" : "file",
        noticeType,
        applyType ? applyType : permissionType
      );
    };

    const handleJoyspaceLink = async (url: string) => {
      const result = getFolderInfo(url);
      const isFolder = result?.length && result?.length > 2 && result[1] === "folder_view";
      doAnalysisLogONCardClick(!!isFolder);
      if (isFolder) {
        const fileId = result?.[2] || "";
        const res: any = await API.categories.info(fileId);
        let folderInfo = [];
        console.log("API.categories.info======>", res);
        if (!res) {
          // 解决打开文件夹无权限问题及删除问题
          folderInfo = [
            {
              id: fileId,
              parent: "",
              space_id: fileId,
              type: 12,
              full_name: message.content,
              full_path: fileId,
              name: message.content,
              origin: "AICard"
            }
          ];
        } else {
          folderInfo = [res];
        }
        console.log(folderInfo, "folderInfo======>", res);
        addFolderInfo(folderInfo);
        history.push(`/joyspace/teamspace?categoryId=${fileId}`);
      } else {
        handleLinkClick(url);
      }
    };

    const handleClick = async (btn: any, url: string) => {
      // console.log(btn, 'btnbtnbtnbtnbtn');
      const isFolder = !!getFolderInfo(url);
      let reslut: any = null;
      // 同意
      if (btn.action === BtnsType.DETAIL || btn.action === BtnsType.APPLYAGAIN) {
        handleJoyspaceLink(btn.params.deepLink);
        return;
      } else {
        reslut = await approval(btn.action, btn.params.applyCode, extend.extendParameters, id);
        doAnalysisLogONCardClick(isFolder, btn.action);
      }
      if (reslut.code !== "200") {
        Message.error(reslut.status || "操作失败");
      }
    };
    const buttons: any[] = extend.btns;
    return (
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(message.sender.avatar)}
        type={duccConfigI18.joyspace}
        contentList={extend.fields}
        title={title}
        handleDetail={() => {
          handleJoyspaceLink(extend.url || "");
        }}
        loadButtonsFn={
          buttons
            ? () => {
                return (
                  <div className="button_items">
                    {buttons.map((btn: any = {}, idx) => {
                      return (
                        <button
                          className={btn.status === "0" ? "disable" : ""}
                          disabled={btn.status === "0" ? true : false}
                          key={idx}
                          onClick={() => handleClick(btn, extend.url || "")}
                        >
                          {buttons.length === 1 &&
                            btn.status === "0" &&
                            btn.action === BtnsType.APPROVE && (
                              <IconFont
                                type="iconlog_message"
                                style={{ color: "#00A645", marginRight: 6 }}
                              />
                            )}
                          {buttons.length === 1 &&
                            btn.status === "0" &&
                            btn.action === BtnsType.REJECT && (
                              <IconFont
                                type="iconlog_message"
                                style={{ color: "#EE0A24", marginRight: 6 }}
                              />
                            )}
                          {btn.name}
                        </button>
                      );
                    })}
                  </div>
                );
              }
            : () => (
                <div className="button_item" onClick={() => handleJoyspaceLink(extend.url || "")}>
                  {t("click-to-view")}
                </div>
              )
        }
        // loadButtonsFn={() => (
        //     <div className="button_item" onClick={() => handleLinkClick(extend.url || '')}>
        //         {t('click-to-view')}
        //     </div>
        // )}
      />
    );
  }
);

export default JoyspaceNoticeCard;
